/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRouteMatch, useHistory, Link } from "react-router-dom";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { toast } from "react-toastify";
import moment from "moment";

import { getMandado } from "../../../services/apiConsultaMandado";
import { DadosCadastro, DadosMandado } from "../../../interface/fichaMandado";

import { useAuth } from "../../../hooks/auth";

import { LabelInfo } from "../../../components";

interface PropsId {
  CADASTRO: string;
}

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const FichaMandado: React.FC = () => {
  const history = useHistory();
  const [dadosPessoal, setDadosPessoal] = useState<DadosCadastro | null>(null);
  const [dadosMandado, setDadosMandado] = useState<DadosMandado[] | null>(null);
  const [loading, setLoading] = useState(true);
  const { params } = useRouteMatch<PropsId>();

  const { logout, user } = useAuth();

  useEffect(() => {
    async function consultaFichaMandado() {
      await getMandado(params.CADASTRO)
        .then((response) => {
          if (response.status === 200) {
            setDadosPessoal(response.data.pessoa[0]);
            setDadosMandado(response.data.pessoa[0].dados_mandado);
          }
          if (response.status === 404) {
            toast.error("HOUVE ALGUM ERRO NA REQUISIÇÃO, TENTE NOVAMENTE.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
          }
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        });
    }

    consultaFichaMandado();
  }, []);

  const imprimir = () => {
    window.print();
  };

  const voltar = () => {
    history.goBack();
  };

  const theme = MUI.useTheme();

  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection="row"
      width="100%"
      height="80vh"
      overflow="auto"
      sx={{
        "@media print": {
          overflow: "hidden !important",
          height: "100%",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack p={2} flex={1}>
        <MUI.Stack
          mb={1}
          gap={[1, 0]}
          width="100%"
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.Button
            variant="contained"
            startIcon={<Icon.KeyboardReturn />}
            onClick={voltar}
          >
            Voltar para pesquisa
          </MUI.Button>
          <MUI.Button variant="contained" onClick={imprimir}>
            Imprimir
          </MUI.Button>
        </MUI.Stack>

        {!loading ? (
          <>
            {dadosPessoal && (
              <MUI.Stack>
                <MUI.Typography
                  bgcolor={theme.palette.secondary.light}
                  variant="h6"
                >
                  Ficha Dados pessoais
                </MUI.Typography>
                <MUI.Divider
                  sx={{
                    borderWidth: 1.5,
                    backgroundColor: `${theme.palette.secondary.contrastText}`,
                  }}
                />
                <MUI.Grid container spacing={1} py={1}>
                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo label="Nome:" info={dadosPessoal?.NOME1} />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Vulgo:"
                      info={dadosPessoal?.VULGO1 || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="RG:"
                      info={dadosPessoal?.IDENTIDADE || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="CPF:"
                      info={dadosPessoal?.CPF || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Data de nascimento:"
                      info={
                        dadosPessoal.DATANASC
                          ? moment(dadosPessoal?.DATANASC).format("DD/MM/YYYY")
                          : "Não informado"
                      }
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Idade:"
                      info={dadosPessoal?.IDADE || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Mãe:"
                      info={dadosPessoal?.NOMEMAE || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Pai:"
                      info={dadosPessoal?.NOMEPAI || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Endereço:"
                      info={dadosPessoal?.LOGRADOURO || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="UF:"
                      info={dadosPessoal?.UF || "Não informado"}
                    />
                  </MUI.Grid>
                </MUI.Grid>
              </MUI.Stack>
            )}

            {dadosMandado?.map((mandadoInfo) => (
              <MUI.Stack pb={2}>
                <MUI.Typography
                  bgcolor={theme.palette.secondary.light}
                  variant="h6"
                >
                  Ficha Dados Mandado
                </MUI.Typography>
                <MUI.Divider
                  sx={{
                    borderWidth: 1.5,
                    backgroundColor: `${theme.palette.secondary.contrastText}`,
                  }}
                />
                <MUI.Grid container spacing={1} py={1}>
                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Colecionador:"
                      info={mandadoInfo?.COLECIONA || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Setença:"
                      info={mandadoInfo?.SENTENCA || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Incurso nas penas do art.:"
                      info={mandadoInfo?.INCURSO || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Comarca:"
                      info={mandadoInfo?.DESCRICAO_COMARCA || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Vara:"
                      info={mandadoInfo?.VARA || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Local de prisão:"
                      info={mandadoInfo?.LOCALPRI || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Local do crime:"
                      info={mandadoInfo?.CID_CRIME || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Data do mandado:"
                      info={
                        moment(mandadoInfo?.DATAMAN).format("DD/MM/YYYY") ||
                        "Não informado"
                      }
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    {mandadoInfo?.crime.map((crime) => (
                      <LabelInfo
                        label="Crime:"
                        info={crime.nome || "Não informado"}
                      />
                    ))}
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Situação:"
                      info={mandadoInfo?.TIPO_SITUACAO || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Processo:"
                      info={mandadoInfo?.PROCESSO || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Tipo do mandado:"
                      info={mandadoInfo?.TIPO_MANDADO || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Responsável:"
                      info={mandadoInfo?.NOMERESP || "Não informado"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                    <LabelInfo
                      label="Histórico:"
                      info={mandadoInfo?.HISTORICO || "Não informado"}
                    />
                  </MUI.Grid>
                </MUI.Grid>
              </MUI.Stack>
            ))}
          </>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
